import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.secondary};
  border: solid ${pxToRem(1)} ${theme.swatches.warm[50]};
`;
